import React from "react";
import styles from "./HomePage.module.css";
//components
import { OfferCategoriesList } from "../../components/OfferCategories";
import { SliderList } from "../../components/Slider";
import { CardList } from "../../components/Card";
import Title from "../../components/Title";
import NewSellerSubscribeForm from "../../components/NewSellerSubscribeForm";
import BonusInformation from "components/BonusInformation/BonusInformation";

const HomePage = () => {
  return (
    <section className={styles.section}>
      <div className={styles.item}>
        <SliderList />
      </div>

      <div className={styles.item}>
        <OfferCategoriesList />
      </div>

      <div className={styles.item}>
        <BonusInformation />
      </div>

      <div className={styles.item}>
        {/* product */}
        <Title name="Sản Phẩm Mới" />
        <CardList itemOnPage={12} itemOnRow={4} />
      </div>

      <div className={styles.item}>
        {/* product */}
        <Title name="Subscribe NEWSLETTER" />
        <NewSellerSubscribeForm />
      </div>
    </section>
  );
};

export default HomePage;
